(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bh-design-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bh-design-slideshow')) {
    customElements.define('bh-design-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bhd__track');
        this.slides = [...this.querySelectorAll('.bhd__slide')];
        if (!this.track || this.slides.length < 2) return;
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.editing = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();
        const listen = (target, event, handler) => target.addEventListener(event, handler, {signal:this.abort.signal});
        this.querySelector('.bhd__controls').hidden = false;
        listen(this.querySelector('[data-previous]'), 'click', () => this.go(this.index - 1));
        listen(this.querySelector('[data-next]'), 'click', () => this.go(this.index + 1));
        listen(this.track, 'scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(Math.abs(this.track.scrollLeft) / this.track.clientWidth)));
            this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
          });
        });
        listen(this.track, 'keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        const pause = this.querySelector('[data-pause]');
        if (pause) listen(pause, 'click', () => {
          this.paused = !this.paused;
          pause.textContent = this.paused ? 'Play' : 'Pause';
          pause.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
          pause.setAttribute('aria-pressed', String(this.paused));
          this.schedule();
        });
        listen(this, 'mouseenter', () => {this.hovered = true; this.schedule();});
        listen(this, 'mouseleave', () => {this.hovered = false; this.schedule();});
        listen(this, 'focusin', () => {this.focused = true; this.schedule();});
        listen(this, 'focusout', () => {this.focused = false; this.schedule();});
        listen(document, 'visibilitychange', () => this.schedule());
        listen(this.motion, 'change', () => this.schedule());
        listen(this, 'shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) {this.editing = true; this.schedule(); this.go(index, true);}
        });
        listen(this, 'shopify:block:deselect', () => {this.editing = false; this.schedule();});
        this.schedule();
      }
      go(index, immediate = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({left:this.index * this.track.clientWidth,behavior:immediate || this.motion.matches ? 'instant' : 'smooth'});
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.dataset.autoplay !== 'true' || this.paused || this.hovered || this.focused || this.editing || document.hidden || this.motion.matches) return;
        this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval) || 6000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
        if (this.abort) this.abort.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magpie-department-edits"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('.mde__jump a');if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;const target=document.getElementById(link.hash.slice(1));if(!target)return;event.preventDefault();const details=target.querySelector('details');if(details)details.open=true;target.focus({preventScroll:true});target.scrollIntoView({block:'start',behavior:'instant'});});

document.querySelectorAll('[data-magpie-stock-directory]').forEach(function(directory){
 let checked=false;
 directory.addEventListener('toggle',async function(){
  if(!directory.open||checked)return;
  checked=true;
  const links=Array.from(directory.querySelectorAll('[data-magpie-stock-link]'));
  const pending=links.slice();let failed=0;let shown=0;
  async function worker(){
   while(pending.length){
    const link=pending.shift();
    try{
     const url=new URL(link.href);url.searchParams.set('filter.v.availability','1');url.searchParams.set('section_id','magpie-stock-status');
     const response=await fetch(url.toString(),{credentials:'same-origin'});
     if(!response.ok)throw new Error('stock check');
     const doc=new DOMParser().parseFromString(await response.text(),'text/html');
     const status=doc.querySelector('[data-magpie-stock-count]');
     if(!status)throw new Error('missing stock');
     const count=Number(status.dataset.magpieStockCount);
     if(count>0){link.hidden=false;shown++;}
    }catch(error){failed++;}
   }
  }
  await Promise.all([worker(),worker(),worker(),worker()]);
  const message=directory.querySelector('[data-stock-message]');
  if(failed){message.textContent='Some designers could not be checked. Close and reopen to try again.';checked=false;}
  else if(!shown){message.textContent='New designer arrivals are on their way. Explore our latest arrivals above.';}
  else message.hidden=true;
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magpie-story-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('magpie-story-slider')) {
  customElements.define('magpie-story-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.track = this.querySelector('.msb-slider__track');
      this.slides = [...this.querySelectorAll('.msb-slider__slide')];
      this.buttons = [...this.querySelectorAll('[data-step]')];
      this.status = this.querySelector('.msb-slider__status');
      if (!this.track || !this.slides.length) return;
      this.classList.add('msb-slider--ready');
      this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.step)), options));
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.track.addEventListener('scroll', () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.update(), 120); }, options);
      document.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.msb-slider__slide');
        if (slide && this.contains(slide)) this.track.scrollTo({left: slide.offsetLeft - this.slides[0].offsetLeft, behavior:'auto'});
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    move(direction) {
      const step = this.slides.length > 1 ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.track.clientWidth;
      this.track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    update() {
      const left = this.track.scrollLeft;
      this.buttons[0].disabled = left <= 2;
      this.buttons[1].disabled = left >= this.track.scrollWidth - this.track.clientWidth - 2;
      const box = this.track.getBoundingClientRect();
      const shown = this.slides.map((slide,index) => ({index,box:slide.getBoundingClientRect()})).filter(slide=>slide.box.right>box.left+5 && slide.box.left<box.right-5);
      if (shown.length) this.status.textContent = (shown[0].index+1)+'–'+(shown[shown.length-1].index+1)+' / '+this.slides.length;
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
